module.exports = __webpack_public_path__ + "static/img/l-5.9abf21a1.png";